export default {
    address: {
        city: "市",
        city_locality: "市区町村",
        country: "国",
        line1: "住所1",
        line2: "住所2",
        postal_code: "郵便番号",
        state: "州",
        state_region: "州\/地域"
    },
    alerts: {
        account_2fa: "2 要素認証でアカウントを保護します。",
        account_2fa_success: "2要素認証が有効になっています。",
        activate_instruction: "自動レビュー収集を有効にすると、{count} からレビューをリクエストしようとします。有効にする前にテンプレートを確認してください。",
        activate_intro: "戦略に基づいて継続的にレビューをリクエストします。",
        agency_mcp_server: "Claudeまたはその他のMCPクライアントを、貴社のMCPサーバーに接続してください。承認されたアシスタントが、貴社に代わってプロジェクト、クライアント、チームを管理できます。",
        ai_assistant: "Ai を使用してレビューの提案や返信を行うには、会社名と説明が必要です。",
        api_key_roll: "Apiキーを変更してもよろしいですか? 変更すると、そのキーを使用しているすべてのアプリケーションに影響します。",
        ask_confirm: "{count} にレビューをリクエストしてもよろしいですか? これにより、まだリクエストされていないすべての顧客に対するリクエストがスケジュールされます。",
        cname_delete: "CNAME: {cname_name} を削除してもよろしいですか?",
        cname_not_configured: "このレコードはまだ設定されていません。しばらくお待ちください...",
        cname_warning: "顧客にすでに送信されたメッセージには壊れたリンクが含まれます。",
        connection_disabled: "接続が無効です。再接続してください。",
        customer_archive: "顧客 {customer_name} をアーカイブしてもよろしいですか? 未送信のメッセージはすべてキャンセルされます。",
        customer_cancel: "顧客：{customer_name} の未送信メッセージをすべてキャンセルしてもよろしいですか?",
        customer_ingest: "顧客にメールを送信するときに、このメール アドレスをbccフィールドに含めると、顧客の名前とメール アドレスが自動的にインポートされます。",
        customer_resubscribe: "顧客 {customer_name} を再登録してもよろしいですか?",
        customer_unarchive: "顧客 {customer_name} をアーカイブ解除してもよろしいですか?",
        customer_unsubscribe: "顧客 {customer_name} の登録を解除してもよろしいですか?",
        customer_unsubscribe_all: "{count} がこのプロジェクトからのメッセージを受信しないように登録解除してもよろしいですか?",
        delete: "{model}: {name} を削除してもよろしいですか?",
        delete_count: "{count} を削除してもよろしいですか?",
        domain_agency: "独自の送信ドメインを追加して、代理店を完全にホワイト ラベル化します。",
        domain_delete: "ドメイン「{name}」を削除してもよろしいですか？ 引き続き弊社のドメイン名からメールをお送りします。",
        domain_dmarc: "ドメインにdmarcレコードを追加すると、メールがスパムとして分類される可能性が低くなります。",
        domain_project: "送信ドメインを追加すると、独自のドメイン名から顧客にメールを送信できるようになります。",
        export_confirm: "{model} をすべてエクスポートしてもよろしいですか?",
        export_count: "{count} をエクスポートしてもよろしいですか?",
        export_link: "リクエスト後すぐにダウンロード リンクが {email} に送信されます。",
        highlights_save_disabled: "必要に応じて、現在ハイライトが設定されているすべてのレビューからハイライトを削除できます。",
        highlights_save_enabled: "すべての肯定的なレビューにハイライト表示を適用するには、下のチェックボックスをオンにしてください。ハイライトの色のみを変更する場合は、チェックボックスをオフにしたままにしてください。",
        integration_disconnect: "{integration_name} から切断してもよろしいですか?",
        integration_sync: "{integration_name} アカウントを同期してもよろしいですか？データは継続的にインポートされます。",
        intro: "お客様からもっと良いレビューをもらいたいですか？まずは顧客をインポートしてください。その後、手動でレビューを依頼するか、「自動化」ボタンを押してレビューを自動で送信しましょう。",
        logout: "ログアウトしてもよろしいですか?",
        mcp_server: "Claudeまたは任意のMCPクライアントをこのプロジェクトに接続してください。MCPサーバーを使用すると、 AIアシスタントがお客様に代わってレビュー、顧客、メッセージを読み取って管理できます。",
        member_confirm: "本当に自分自身を削除してもよろしいですか？このプロジェクトにアクセスできなくなります。",
        member_confirm_all: "本当に自分自身を削除してもよろしいですか？すべてのプロジェクトにアクセスできなくなります。",
        member_other_confirm: "{noun}: {name} を削除してもよろしいですか? 削除すると、このプロジェクトへのアクセス権が失われます。",
        member_other_confirm_all: "{noun} {name} を削除してもよろしいですか? 削除すると、すべてのプロジェクトにアクセスできなくなります。",
        message_cancel: "このメッセージをキャンセルしてもよろしいですか?",
        message_cancel_all: "{count} をキャンセルしてもよろしいですか? この操作は未送信のメッセージに対してのみ実行できます。",
        message_delete: "このメッセージを削除してもよろしいですか?",
        oauth_client_revoke: "本当に{client}のアクセス権を取り消しますか？アクティブなセッションはすべて即座に切断されます。",
        project_summary: "現時点では概要を生成できません。",
        project_suspend: "プロジェクト {project_name} を一時停止してもよろしいですか?",
        project_unsuspend: "プロジェクト {project_name} の一時停止を解除してもよろしいですか?",
        review_delete: "このレビューを削除してもよろしいですか? この操作は元に戻せません。",
        review_page_confirm: "変更を保存してもよろしいですか?",
        review_page_default: "レビュー ページ {name} をデフォルトのページにしますか? レビュー リクエストに他のページが割り当てられていない場合は、このページが使用されます。",
        review_page_delete: "レビューページ {name} を削除してもよろしいですか? 現在このページに誘導されているすべての顧客は、デフォルトページに誘導されます。",
        review_page_delete_all: "{count} を削除してもよろしいですか? デフォルトのレビュー ページは削除されません。",
        review_page_fields: "レビューを投稿する際に、フィールドを使って顧客情報を取得します。フォームにフィールドを追加し、顧客が評価を選択した際に条件に応じて表示します。",
        review_page_instructions: "評価を選択した後、フォームのすぐ上に指示を表示します。",
        review_page_location_picker: "顧客がレビューの対象としてプロジェクト内の任意の場所を選択できるようにします。レビューページが特定の場所に表示されるように設定されている場合、この場所は事前に選択されています。",
        review_page_locations: "このレビューページを使用する場所を選択してください。1つの場所は1つのレビューページにのみ割り当てられます。場所に割り当てられていない場合は、デフォルトのレビューページが使用されます。",
        review_page_redirects: "評価を選択した後はフォームをスキップし、別のサイトにリダイレクトします。また、評価ごとに複数のリダイレクトを追加することで、トラフィックを複数のウェブサイトに分割することもできます。",
        share_template_delete: "共有テンプレート「{name}」を削除してもよろしいですか？この操作は元に戻せません。",
        smtp_remove: "プロジェクトからsmtp設定を削除してもよろしいですか? 送信ドメインは標準設定に戻ります。",
        smtp_setup: "ご自身のメールサーバーからメールを送信してください。SMTP情報を入力してください。サーバーでIPアドレス制限が設定されている場合は、システムで使用されている以下のIPアドレスをホワイトリストに登録してください：{ips}。",
        space_delete: "スペース{name} を削除してもよろしいですか? スペース内のすべてのプロジェクトが削除されます。",
        tag_rule: "肯定的な用語と否定的な用語を追加してください。該当する場合、AIが自動的にレビューにタグ付けします。",
        user_delete: "{email} のユーザー アカウントを削除してもよろしいですか?",
        user_verify: "メールアドレスを確認してアカウントを有効にするには、{email} に送信されたメール内のリンクをクリックします。",
        widget_delete: "ウィジェット「{name}」を削除してもよろしいですか？ウィジェットはどのウェブサイトにも表示されなくなります。",
        widget_restore: "ウィジェット：{name} の設定を復元してもよろしいですか？ デザインのみがデフォルト値に戻ります。",
        widgets_1: "このスクリプトをウェブサイトの本文に追加します。",
        widgets_2: "レビューウォールでは、すべてのレビューがグリッド形式で表示されます。ウィジェットを表示したい場所にこのスクリプトを追加してください。",
        widgets_3: "レビュースポットライトは、1件の大きなレビューを表示します。ウィジェットを表示したい場所にこのスクリプトを追加してください。"
    },
    billing_statuses: {
        active: "サブスクリプションはアクティブです。",
        canceled: "サブスクリプションはキャンセルされました。続行するにはアップグレードしてください。",
        trial: "無料トライアルは {date} に終了します。",
        trial_expired: "無料トライアルは終了しました。続行するにはアップグレードしてください。",
        trial_expiring: "無料トライアルはまもなく終了します。続行するにはアップグレードしてください。"
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "メール",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "メッセンジャー",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "スレッド",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "メールアドレスを編集するには、送信ドメインを追加します。",
        agency_robots: "検索エンジンが顧客ポータルをインデックスできるようにします。",
        ai_business_description: "レビューの提案や返信の生成に役立つ、ビジネスの詳細な説明。",
        ai_business_name: "あなたの会社の名前。",
        ask_location: "レビューに割り当てる場所。",
        ask_review_page: "レビューをキャプチャするページ。",
        assign_tags: "レビューにタグを割り当てます。",
        csv_max_rows: "最大{count}行",
        dashboard_configure_settings: "プロジェクト設定を構成します。",
        dashboard_import_customers: "顧客をインポートします。",
        dashboard_preview_email_templates: "電子メール テンプレートをプレビューします。",
        dashboard_preview_kiosk_page: "キオスク ページをプレビューします。",
        dashboard_preview_review_page: "レビュー ページをプレビューします。",
        dashboard_preview_showcase_page: "ショーケースページをプレビューします。",
        logo_height: "電子メールおよびページ上のロゴの高さ。",
        meta_description: "ページの説明を上書きします。",
        meta_title: "ページタイトルを上書きします。",
        mfa_password: "アカウントのパスワードを入力してください。",
        mfa_qr_code: "認証アプリで qr コードをスキャンします。",
        mfa_security_code: "認証アプリからのコードを入力します。",
        override_ambassador: "クライアントのメール、ページ、ウィジェットにバッジを表示します。",
        project_name: "ビジネス、ブランド、またはウェブサイトの名前。",
        project_robots: "検索エンジンがレビューページとショーケースをインデックスできるようにします。",
        project_slug: "Cnameが設定されていない場合、顧客向けの電子メールやリンクで使用されます。",
        review_page_copied_message: "肯定的なレビューが送信された後に表示されます。",
        review_page_email_address: "このメールでレビューを受け取ります。",
        review_page_link_reveal_position: "リンクを公開する場所。",
        review_page_link_revealer_label: "リンクを明らかにするラベル。",
        review_page_link_revealer_rating: "顧客がこの評価以上を選択した場合はリンクを表示し、それ以外の場合はリンクを表示するためのボタンを表示します。",
        review_page_native_reviews: "このプラットフォームでのレビューを許可します。",
        review_page_rating_selection: "レビューを送信する前に評価を保存。",
        review_page_success_button_link: "空白の場合、リンクはデフォルトでプロジェクトの Web サイトに設定され、それ以外の場合はページのドメインになります。",
        review_page_warning: "顧客が公開レビューを残せないようにすると、ビジネス リストが削除される可能性があります。",
        review_reply_status: "このレビューには公開で返信できません。代わりに、レビュー投稿者に直接ご連絡ください。",
        review_suggestions: "顧客がレビューを書くのを手伝います。",
        separate_with_commas: "複数指定する場合はコンマで区切ります。",
        showcase_locations: "ショーケースを特定の場所に限定します。",
        showcase_review_length: "レビューは少なくともこの文字数である必要があります。",
        showcase_since: "この日付以前に作成されたレビューを表示します。",
        showcase_sources: "ショーケースを特定のソースに制限します。",
        showcase_tags: "ショーケースを特定のタグが付いたレビューに制限します。",
        signature_html: "署名をコピーしてメールアプリケーションに貼り付けてください。",
        signed_up: "顧客の開始日。",
        twilio_webhook: "メッセージング サービスのコールバックurlとして設定します。",
        widget_embed: "ウィジェットが表示される div コンテナのID属性。"
    },
    labels: {
        accept_all: "すべて受け入れる",
        access_code: "アクセスコード",
        access_codes: "アクセスコード",
        account: "アカウント",
        account_sid: "アカウントsid",
        action: "アクション",
        actions: "アクション",
        activate: "有効化",
        active: "アクティブ",
        active_subscription: "アクティブなサブスクリプション",
        add: "追加",
        add_agency_project: "代理店プロジェクトを追加する",
        add_confirmation_message: "確認メッセージを追加します。",
        add_css_rules: "独自の css ルールを追加します。",
        add_custom_field: "カスタムフィールドを追加",
        add_customer: "顧客を追加する",
        add_customers_with: "{model} で顧客を追加する",
        add_external_link: "外部リンクを追加する",
        add_external_links: "外部リンクを追加する",
        add_introduction: "紹介を追加します。",
        add_js_tags: "独自のJavaScriptタグを追加します。",
        add_legal_information: "法的情報を追加します。",
        add_location: "場所を追加する",
        add_project: "プロジェクトを追加する",
        add_review: "レビューを追加する",
        add_tag: "タグを追加する",
        added: "追加した",
        address: "住所",
        advanced_review_pages: "高度なレビューページ",
        affiliates: "関連会社",
        age_of_reviews: "レビューの経過期間",
        agency: "代理店",
        agency_name: "代理店名",
        agency_project: "エージェンシープロジェクト",
        agency_projects: "代理店プロジェクト",
        ai: "人工知能",
        ai_assistant: "Aiアシスタント",
        ai_auto_tagging: "Ai自動タグ付け",
        ai_reviews_and_replies: "Aiによるレビューの提案と返信",
        ai_tagging_instructions: "例: 待ち時間、サービスの遅さ、遅延について言及しているレビューに適用します。",
        all: "全て",
        allowed_domains: "許可されたドメイン",
        amount: "額",
        analytics: "分析",
        and: "そして",
        anonymous_reviews: "匿名のレビュー",
        answer: "答え",
        any: "どれでも",
        api: "API",
        api_key: "Apiキー",
        appearance: "外観",
        approved: "承認された",
        archive: "アーカイブ",
        archive_customer: "アーカイブ顧客",
        archived: "アーカイブ済み",
        at_least: "少なくとも",
        at_least_days: "少なくとも{num}日",
        at_least_hours: "少なくとも{num}時間",
        at_least_months: "少なくとも{num}か月",
        at_most: "せいぜい",
        at_most_days: "最大{num}日",
        at_most_hours: "最大{num}時間",
        at_most_months: "最大{num}か月",
        auth_token: "認証トークン",
        authorize: "承認する",
        auto_detect: "自動検出",
        auto_tags: "自動タグ",
        automate: "自動化",
        automate_highlights: "ハイライトを自動化",
        automate_replies: "自動返信",
        automatic_review_collection: "自動レビュー収集",
        automatically_apply_tags: "既存のレビューにタグを自動的に適用する",
        automating: "自動化",
        avatar: "アバター",
        avatars: "アバター",
        average_charge: "平均料金",
        average_review: "平均レビュー",
        background_color: "背景色",
        background_image: "背景画像",
        bcc: "BCC",
        bcc_email_address: "Bccメールアドレス",
        best_to_worst: "最高から最低",
        billing: "請求",
        blog: "ブログ",
        body: "本文",
        body_font_size: "本文のフォントサイズ",
        bold: "太字",
        bottom: "底",
        bottom_left: "左下",
        bottom_right: "右下",
        build_on: "{model} をベースに構築",
        business_description: "事業内容",
        business_email: "サポートメールアドレス",
        business_name: "会社名",
        business_phone: "サポート電話番号",
        business_website: "ビジネスウェブサイト",
        button: "ボタン",
        button_label: "ボタンのラベル",
        button_link: "ボタンのリンク",
        button_position: "ボタンの位置",
        button_size: "ボタンのサイズ",
        buy_me_a_coffee: "コーヒーを買ってください",
        by: "による",
        by_signing_up: "アカウントを作成することにより、お客様は当社の",
        call_to_action: "行動喚起",
        cancel: "キャンセル",
        cancel_1_message: "キャンセル 1 メッセージ",
        cancel_message: "メッセージをキャンセル",
        cancel_messages: "{count} メッセージをキャンセル",
        cancel_subscription: "サブスクリプションをキャンセルする",
        cancel_unsent_messages: "未送信メッセージをキャンセル",
        canceled: "キャンセル",
        center: "中心",
        change: "変化",
        change_key: "Apiキーを変更する",
        change_plan: "プランの変更",
        changelog: "変更履歴",
        channel: "チャネル",
        channels: "チャンネル",
        characters: "文字",
        charges_avg: "平均料金は少なくとも",
        charges_count: "請求回数は少なくとも",
        charges_sum: "合計料金は少なくとも",
        checkbox: "チェックボックス",
        claude: "クロード",
        clear: "クリア",
        clear_highlights_from_reviews: "すべてのレビューからハイライトを削除する",
        clicked: "クリックしました",
        client: "クライアント",
        clients: "クライアント",
        cloudflare_warning: "Cloudflareを使用する場合は、プロキシをオフにする必要があります。",
        cname: "CNAME",
        cname_setup_incomplete: "設定が完了していません - {date}で削除されます",
        cname_ssl_pending: "Ssl証明書を待っています",
        cname_status_for: "Cnameステータス",
        code_editor: "コードエディター",
        collapse: "折りたたむ",
        collect_reviews_anywhere: "どこからでもレビューを収集",
        color: "色",
        colors: "色",
        commission_rate: "手数料率",
        commission_status_approved: "承認された",
        commission_status_paid: "支払済み",
        commission_status_pending: "保留中",
        commission_status_reversed: "逆",
        community: "コミュニティ",
        company: "会社",
        complained: "苦情を申し立てた",
        confirm_new_password: "新しいパスワードの確認",
        confirmation_message: "確認メッセージ",
        connect: "接続する",
        connect_bank: "銀行口座を連携させる",
        connected: "接続",
        consent_preferences: "同意の設定",
        contact_customer: "顧客に連絡する",
        contact_support: "サポートにお問い合わせください。",
        contact_us: "お問い合わせ",
        container_element: "コンテナ要素",
        context: "コンテクスト",
        continue: "続く",
        continue_with_google: "Googleで続行",
        cookie_category_analytics: "分析",
        cookie_category_essential: "不可欠",
        cookie_category_functional: "機能的",
        cookie_category_marketing: "マーケティング",
        cookie_consent_banner: "クッキー同意バナー",
        cookie_consent_scope_all: "みんなに見せる",
        cookie_consent_scope_eea: "Eeaおよび英国からの訪問者のみに表示",
        cookie_consent_scope_none: "表示しない",
        cookie_policy: "クッキーポリシー",
        cookie_preference: "クッキーの設定",
        copied: "コピーしました",
        copied_message: "コピーされたメッセージ",
        copy: "コピー",
        copy_embed_code: "埋め込みコードをコピー",
        copy_signature: "署名のコピー",
        copy_source_code: "ソースコードをコピー",
        copy_uuid: "Uuidをコピー",
        create: "作成する",
        create_account: "アカウントを作成する",
        create_agency: "代理店を作成する",
        create_cname: "Cnameレコードを作成し、",
        create_external_link: "外部リンクを作成する",
        create_field: "フィールドを作成する",
        create_link: "リンクを作成する",
        create_location: "場所を作成する",
        create_project: "プロジェクトを作成する",
        create_qr_code: "Qrコードを作成する",
        create_review: "レビューを作成する",
        create_review_page: "レビューページを作成する",
        create_signature: "署名を作成する",
        create_source: "ソースを作成する",
        create_space: "スペースを作成する",
        create_tag: "タグを作成する",
        create_tag_rule: "タグルールを作成する",
        create_webhook: "Webhookを作成する",
        create_widget: "ウィジェットを作成する",
        crms: "CRMs",
        csv: "CSV",
        currency: "通貨",
        current_plan: "現在の計画",
        current_year: "現在の年",
        custom_field: "カスタムフィールド",
        custom_instructions: "カスタム指示",
        custom_url: "カスタムurl",
        customer: "お客様",
        customer_name_convention: "顧客名の表記規則",
        customer_reviews: "顧客レビュー",
        customers: "顧客",
        customize: "カスタマイズ",
        customize_review_page: "レビューページをカスタマイズ",
        daily: "毎日",
        daily_email_requests: "毎日のメールリクエスト",
        daily_limit: "1日の制限",
        daily_requests: "毎日のリクエスト",
        daily_sms_requests: "毎日のsmsリクエスト",
        dark: "暗い",
        dashboard: "ダッシュボード",
        date: "日付",
        date_added: "追加日",
        date_canceled: "キャンセル日",
        date_clicked: "クリック日",
        date_complained: "苦情申し立て日",
        date_delivered: "納品日",
        date_failed: "日付が失敗しました",
        date_messaged: "メッセージ送信日",
        date_opened: "開設日",
        date_replied: "返信日",
        date_requested: "申請日",
        date_reviewed: "レビュー済み日",
        date_scheduled: "予定日",
        date_sent: "送信日",
        date_signed_up: "登録日",
        date_updated: "更新日",
        dates: "日付",
        day: "日",
        days: "日数",
        days_after_last_request: "最後のリクエストから日数",
        days_later: "数日後",
        deactivate: "無効化",
        default: "デフォルト",
        default_language: "デフォルト言語",
        default_review_page: "デフォルトのレビューページ",
        default_review_visibility: "デフォルトのレビュー表示",
        default_tone: "デフォルトのトーン",
        delay: "遅れ",
        delete: "削除",
        delete_1_customer: "顧客1人を削除",
        delete_1_review: "レビューを削除 1件",
        delete_1_review_page: "レビューページを1件削除",
        delete_1_widget: "ウィジェットを1つ削除",
        delete_agency: "代理店を削除",
        delete_custom_field: "カスタムフィールドを削除",
        delete_customer: "顧客を削除",
        delete_customers: "顧客を削除",
        delete_external_link: "外部リンクを削除",
        delete_field: "フィールドを削除",
        delete_link: "リンクを削除",
        delete_location: "場所を削除",
        delete_message: "メッセージを削除",
        delete_n_customers: "{count} の顧客を削除します",
        delete_n_review_pages: "{count}レビューページを削除",
        delete_n_reviews: "{count} 件のレビューを削除",
        delete_n_widgets: "{count}ウィジェットを削除します",
        delete_project: "プロジェクトを削除",
        delete_qr_code: "Qrコードを削除",
        delete_reply: "返信を削除",
        delete_review: "レビューを削除",
        delete_review_page: "レビューページを削除",
        delete_review_pages: "レビューページを削除する",
        delete_reviews: "レビューを削除",
        delete_signature: "署名を削除",
        delete_source: "ソースを削除",
        delete_space: "スペースを削除",
        delete_tag: "タグを削除",
        delete_tag_rule: "タグルールの削除",
        delete_template: "テンプレートを削除",
        delete_user: "ユーザーの削除",
        delete_webhook: "Webhook を削除",
        delete_widget: "ウィジェットを削除",
        delete_widgets: "ウィジェットを削除",
        deleted: "削除済み",
        delivered: "配達済み",
        description: "説明",
        deselect_all: "すべて選択解除",
        disable: "無効にする",
        disable_automatic_review_collection: "自動レビュー収集を無効にする",
        disable_field: "フィールドを無効にする",
        disable_when_links_are_visible: "リンクが表示されているときに無効にする",
        disabled: "無効",
        disconnect: "切断",
        disconnect_integration: "統合を切断",
        discord_community: "Discordコミュニティ",
        display_name: "表示名",
        dmarc: "DMARC",
        dmarc_status_for: "Dmarcステータス",
        do_not_hide_from_public: "公開から非表示にしない",
        do_not_send: "送信しないでください",
        documentation: "ドキュメント",
        domain: "ドメイン",
        domain_name: "ドメイン名",
        dont_have_an_account: "アカウントをお持ちではありませんか？",
        dont_send_thanks: "感謝の気持ちを送らない",
        download: "ダウンロード",
        download_records: "レコードをダウンロード",
        download_template: "テンプレートをダウンロード",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "重複",
        duplicate_project: "プロジェクトの複製",
        duplicate_review_page: "重複レビューページ",
        duplicate_reviews: "重複レビュー",
        duplicate_widget: "ウィジェットを複製",
        edit: "編集",
        edit_1_customer: "顧客1人を編集",
        edit_1_review: "レビューを編集 1件",
        edit_client: "クライアントを編集",
        edit_custom_field: "カスタムフィールドの編集",
        edit_customer: "顧客を編集",
        edit_customers: "顧客を編集",
        edit_field: "編集フィールド",
        edit_link: "リンクを編集",
        edit_location: "場所を編集",
        edit_member: "メンバーを編集する",
        edit_n_customers: "{count} 顧客を編集",
        edit_n_reviews: "{count} 件のレビューを編集",
        edit_notes: "メモを編集",
        edit_qr_code: "Qrコードを編集",
        edit_reviews: "レビューを編集",
        edit_signature: "署名を編集",
        edit_source: "ソースを編集",
        edit_strategy: "編集戦略",
        edit_tag: "タグを編集",
        edit_tag_rule: "タグルールの編集",
        edit_team_member: "編集チームメンバー",
        edit_visibility: "編集の可視性",
        edit_webhook: "Webhookを編集",
        editable_ratings: "編集可能な評価",
        earned: "獲得",
        eligible: "適格",
        email: "メール",
        email_address: "電子メールアドレス",
        email_validation_invalid: "メールの検証に失敗しました",
        email_validation_passed: "メール検証に合格しました",
        email_validation_unknown: "メールを確認できませんでした",
        emails: "メール",
        embed_code: "埋め込みコード",
        enable: "有効にする",
        enable_automatic_review_collection: "自動レビュー収集を有効にする",
        enable_for_all_reviews: "すべてのレビューで有効にする",
        enable_for_positive_reviews: "肯定的なレビューを有効にする",
        enable_on_review_pages: "レビューページで有効にする",
        enabled: "有効",
        end: "終わり",
        ends: "終了",
        exclude: "除外",
        exclude_email: "メールを除外",
        exclude_sms: "Smsを除外",
        excluded_channels: "除外されたチャンネル",
        expand: "拡大する",
        expired: "期限切れ",
        export: "エクスポート",
        export_1_customer: "顧客1件をエクスポート",
        export_1_review: "エクスポート 1レビュー",
        export_all: "すべてエクスポート",
        export_all_customers: "すべての顧客をエクスポート",
        export_all_reviews: "すべてのレビューをエクスポート",
        export_customers: "顧客をエクスポート",
        export_n_customers: "エクスポート {count} 顧客",
        export_n_reviews: "エクスポート {count}レビュー",
        export_reviews: "レビューをエクスポート",
        external_link: "外部リンク",
        external_links: "外部リンク",
        faces: "顔",
        failed: "失敗した",
        feedback: "フィードバック",
        field: "フィールド",
        fields: "フィールド",
        filter: "フィルター",
        first: "初め",
        first_charged: "最初の課金",
        first_name: "ファーストネーム",
        first_name_last_initial: "名、姓の頭文字",
        flag_as_duplicate: "重複としてフラグを立てる",
        font: "フォント",
        font_family: "フォントファミリー",
        font_size: "フォントサイズ",
        footer: "フッター",
        for: "のために",
        forgot_password: "パスワードをお忘れですか",
        form: "フォーム",
        free: "無料",
        free_requests_included: "無料リクエストが含まれています",
        from: "から",
        full_name: "フルネーム",
        generate: "生成する",
        generate_meta: "メタを生成する",
        generate_qr_code: "Qrコードを生成する",
        generate_reply: "返信を生成する",
        generate_review: "レビューを生成する",
        generating: "生成中",
        get_started: "始める",
        get_started_checklist: "開始チェックリスト",
        get_the_lifetime_deal: "生涯契約をゲット",
        getting_started: "はじめる",
        google_fonts: "Googleフォント",
        grouped_by_request: "リクエスト別にグループ化",
        has_links: "リンクあり",
        has_notes: "メモあり",
        has_redirects: "リダイレクトあり",
        have_an_account: "アカウントをお持ちですか?",
        header: "ヘッダ",
        hidden: "隠れた",
        hidden_from_search_engines: "検索エンジンから隠す",
        hidden_reviews: "非表示のレビュー",
        hide: "非表示",
        hide_all_reviews: "すべてのレビューを非表示",
        hide_avatar: "アバターを非表示",
        hide_date: "日付を非表示",
        hide_drop_shadow: "ドロップシャドウを非表示",
        hide_field_label: "フィールドラベルを非表示",
        hide_from_public: "公開から隠す",
        hide_name: "名前を非表示",
        hide_pagination: "ページネーションを非表示",
        highlight_color: "ハイライトカラー",
        host: "ホスト",
        hours: "営業時間",
        icon: "アイコン",
        icon_size: "アイコンサイズ",
        icons: "アイコン",
        id: "ID",
        image: "画像",
        import: "インポート",
        import_address1: "顧客の住所1。",
        import_address2: "顧客の住所2。",
        import_city: "顧客の都市または地域。",
        import_company: "顧客の会社名。",
        import_created_at: "レビューの日付。",
        import_customers: "顧客のインポート",
        import_email: "顧客のメールアドレス。",
        import_first_name: "顧客の名。",
        import_from_boost_space: "Boost.spaceからインポート",
        import_from_facebook: "Facebookからインポート",
        import_from_google: "Googleからインポート",
        import_from_hubspot: "HubSpotからインポート",
        import_from_make_com: "Make.comからインポート",
        import_from_pabbly: "Pabblyからインポート",
        import_from_stripe: "Stripeからインポート",
        import_from_zapier: "Zapierからインポート",
        import_last_name: "顧客の姓。",
        import_list: "カンマ区切りのリスト",
        import_notes: "社内使用のみのメモです。",
        import_phone: "顧客の電話番号。",
        import_postal_code: "顧客の郵便番号。",
        import_recent_reviews: "最近のレビューをインポート",
        import_review: "レビューのテキスト。",
        import_reviews: "レビューをインポート",
        import_score: "1～5の評価。",
        import_signed_up_at: "顧客の開始日。",
        import_slug: "スラッグまたはuuid",
        import_state: "顧客の州または地域。",
        incentive: "インセンティブ",
        include: "含む",
        include_sample_reviews: "サンプルレビューを含める",
        incoming_webhook_url: "受信Webhook URL",
        inherit: "継承",
        initializing: "初期化中",
        initials: "イニシャル",
        insert_variable: "変数を挿入",
        instructions: "説明書",
        integration: "統合",
        integrations: "統合",
        interval: "間隔",
        introduction: "導入",
        invite: "招待する",
        invite_client: "クライアントを招待する",
        invite_failed: "招待に失敗しました",
        invite_member: "メンバーを招待する",
        invite_sent_to: "招待送信先",
        invite_team_member: "チームメンバーを招待する",
        invited: "招待された",
        italic: "イタリック",
        joined: "参加",
        key: "鍵",
        keywords: "キーワード",
        keywords_in_replies: "返信のキーワード",
        keywords_in_reviews: "レビューのキーワード",
        kiosk_page: "キオスクページ",
        label: "ラベル",
        label_font_size: "ラベルのフォントサイズ",
        labels: "ラベル",
        language: "言語",
        languages: "言語",
        large: "大きい",
        last_charged: "最終請求日",
        last_name: "苗字",
        layout: "レイアウト",
        leave: "離れる",
        leave_project: "プロジェクトを休む",
        leave_space: "スペースを空ける",
        left: "左",
        less: "少ない",
        lifecycle_stage: "ライフサイクルステージ",
        lifetime_deal: "生涯契約",
        light: "ライト",
        limit: "制限",
        limits: "制限",
        link: "リンク",
        link_color: "リンクの色",
        link_reveal_position: "リンクの表示位置",
        link_revealer_button: "リンク表示ボタン",
        link_revealer_label: "リンク表示ラベル",
        link_revealer_rating: "リンク表示の評価条件",
        links: "リンク",
        links_per_review_page: "レビューページあたりのリンク",
        list: "リスト",
        list_unsubscribe_headers: "リスト解除ヘッダー",
        load_more: "もっと読み込む",
        loading: "読み込み中",
        location: "位置",
        location_address: "所在地住所",
        location_name: "場所名",
        location_picker: "場所ピッカー",
        locations: "場所",
        locations_limit: "場所の制限",
        locations_to_sync: "同期する場所",
        log_in: "ログイン",
        log_out: "ログアウト",
        logo: "ロゴ",
        logo_height: "ロゴの高さ",
        long: "長さ",
        lowest_rating: "最低評価",
        ltd: "LTD",
        make_default: "デフォルトにする",
        manage: "管理",
        manage_limits: "制限を管理する",
        manage_overrides: "オーバーライドの管理",
        manage_payout_account: "支払い口座の管理",
        manage_subscription: "サブスクリプションの管理",
        manual_entry: "手動入力",
        max: "マックス",
        max_size: "最大サイズ",
        maximum_characters: "最大文字",
        maximum_customers: "最大顧客数",
        maximum_locations: "最大場所",
        maximum_members: "最大メンバー数",
        maximum_review_length: "最大レビュー長",
        maximum_tags: "最大タグ",
        maximum_widgets: "最大ウィジェット数",
        mcp: "Mcpサーバー",
        mcp_server: "Mcpサーバー",
        mcp_server_url: "Mcpサーバーのurl",
        medium: "中くらい",
        member: "メンバー",
        members: "メンバー",
        message: "メッセージ",
        message_link_expiration: "メッセージリンクの有効期限",
        messaged: "メッセージ",
        messages: "メッセージ",
        messages_clicked: "クリックされたメッセージ",
        messages_sent: "送信されたメッセージ",
        messaging_service_sid: "メッセージングサービスsid",
        min: "分",
        min_size: "最小サイズ",
        minimal_delay: "最小限の遅延",
        minimum_characters: "最小文字",
        minutes: "分",
        month: "月",
        monthly: "毎月",
        monthly_email_requests: "月次メールリクエスト",
        monthly_limit: "月間制限",
        monthly_request_limit: "月間リクエスト制限",
        monthly_requests: "月間リクエスト",
        monthly_sms_requests: "月間smsリクエスト",
        months: "月",
        months_free: "{count}ヶ月無料",
        more: "もっと",
        more_clients: "より多くのクライアント",
        more_customers: "より多くの顧客",
        more_options: "その他のオプション",
        more_patients: "より多くの患者",
        more_reviews: "その他のレビュー",
        more_reviews_needed: "要約するにはさらにレビューが必要です",
        more_users: "より多くのユーザー",
        more_visitors: "より多くの訪問者",
        move: "動く",
        moved: "移動しました",
        name: "名前",
        native_reviews: "ネイティブレビュー",
        negative_term: "負の項",
        negative_trends: "ネガティブな傾向",
        new: "新しい",
        new_password: "新しいパスワード",
        no: "いいえ",
        no_available_options: "利用可能なオプションはありません",
        no_credit_card_required: "クレジットカードは不要です",
        no_data_available: "データなし",
        no_negative_trends: "まだマイナスの傾向はない",
        no_positive_trends: "まだ前向きな傾向はない",
        no_reminders: "リマインダーなし",
        no_retries: "再試行なし",
        no_review: "レビューなし",
        none: "なし",
        not_connected: "接続されていません",
        not_reviewed: "未レビュー",
        notes: "注記",
        notifications: "通知",
        now: "今",
        number_of_charges: "請求回数",
        number_of_reminders: "リマインダーの数",
        number_of_retries: "再試行回数",
        number_of_review_suggestions: "レビュー提案の数",
        of: "の",
        off: "オフ",
        on: "の上",
        on_channel: "チャンネル {channel} で。",
        opened: "オープン",
        options: "オプション",
        or_log_in_with_email: "またはメールアドレスでログインしてください",
        or_sign_up_with_email: "またはメールアドレスを使用してください",
        our_reviews: "私たちのレビュー",
        output: "出力",
        page_footer: "ページフッター",
        paid: "支払済み",
        paragraph: "段落",
        password: "パスワード",
        past_month: "先月",
        past_months: "過去{inc}か月",
        past_week: "先週",
        past_year: "過去1年間",
        past_years: "過去{inc}年間",
        paused: "一時停止",
        payment_method: "支払方法",
        payout_status_completed: "完了",
        payout_status_pending: "保留中",
        pending: "保留中",
        pending_deployment: "保留中の展開",
        pending_validation: "検証保留中",
        per_day: "1日あたり",
        per_month: "月額",
        permissions: "権限",
        phone: "電話",
        phone_number: "電話番号",
        pixels: "ピクセル",
        placeholder: "プレースホルダー",
        placement: "配置",
        plan: "プラン",
        plan_bullet1: "メール、ページ、ウィジェットからブランドを削除します",
        plan_bullet2: "顧客向けページやメール送信にドメインを使用する",
        plan_bullet3: "代理店向けホワイトラベルで製品を自分好みにカスタマイズ",
        please_rate_our_service: "当社のサービスについて評価をお願いします",
        png: "PNG",
        policies: "ポリシー",
        popular: "人気のある",
        port: "ポート",
        position: "位置",
        positive_only: "肯定的なレビューのみ",
        positive_term: "肯定的な用語",
        positive_trends: "ポジティブな傾向",
        powered_by: "Powered by",
        preview: "プレビュー",
        preview_kiosk_page: "プレビューキオスクページ",
        preview_review_page: "プレビューレビューページ",
        price: "価格",
        pricing: "価格",
        primary_color: "原色",
        priority: "優先度",
        privacy_policy: "プライバシーポリシー",
        proceed_to_dashboard: "ダッシュボードに進む",
        product: "製品",
        profile: "プロフィール",
        project: "プロジェクト",
        project_name: "プロジェクト名",
        project_paused: "このプロジェクトは一時停止されています。",
        project_suspended: "このプロジェクトは中断されています。",
        project_website: "プロジェクトウェブサイト",
        projects: "プロジェクト",
        projects_limit: "プロジェクト制限",
        publish: "公開",
        publish_changes: "変更を他のすべてのレビューページに公開する",
        published: "出版",
        purchase: "購入",
        qr_code: "Qrコード",
        qr_code_name_placeholder: "テーブル1、フロントデスク",
        qr_codes: "Qrコード",
        quantity: "量",
        query: "クエリ",
        quick_import: "クイックインポート",
        rating: "評価",
        rating_order: "評価順",
        rating_out_of: "評価",
        rating_save_all: "レビューの前に評価を保存",
        rating_save_customer: "顧客レビューの前に評価を保存",
        rating_save_never: "レビュー前に評価を保存しないでください",
        rating_selection: "評価の選択",
        rating_selector: "評価セレクター",
        ratings: "評価",
        read: "読む",
        reapply_highlights_eligible: "Aiを使ってすべての肯定的なレビューのハイライトを再生成する",
        reconnect: "再接続",
        redeem: "引き換える",
        redirects: "リダイレクト",
        refer_and_earn: "紹介して報酬を獲得しよう",
        referral_billing_status_active: "購読済み",
        referral_billing_status_canceled: "キャンセル",
        referral_billing_status_trial: "トライアル",
        referral_billing_status_trial_expired: "試用期間が終了しました",
        referral_billing_status_trial_expiring: "試用期間満了",
        referral_program: "紹介プログラム規約",
        referrals: "紹介",
        refresh: "リフレッシュ",
        regenerate: "再生成",
        reject_all: "すべて拒否",
        related_reviews: "類似のレビュー",
        related_similarity: "類似性",
        remaining: "残り",
        reminder: "リマインダー",
        reminders: "リマインダー",
        remove: "取り除く",
        remove_client: "クライアントを削除",
        remove_cname: "Cnameを削除する",
        remove_domain: "ドメインを削除",
        remove_from_project: "プロジェクトから削除",
        remove_member: "メンバーを削除する",
        remove_smtp_configuration: "Smtp設定を削除する",
        remove_team_member: "チームメンバーを削除する",
        rename: "名前を変更",
        rename_template: "テンプレートの名前変更",
        renews: "更新",
        replied: "返信",
        reply: "返事",
        reply_to: "返信先",
        replying_on: "返信中",
        request: "リクエスト",
        request_date: "リクエスト日",
        request_review: "レビューをリクエストする",
        request_reviews: "レビューをリクエストする",
        requested: "リクエスト",
        requested_review: "リクエストされたレビュー",
        requests: "リクエスト",
        requests_left_this_month: "今月残っているリクエスト数",
        requests_remaining: "残りのリクエスト",
        require_field: "必須フィールド",
        require_subscription: "顧客は有効なサブスクリプションを持っている必要があります",
        required: "必須",
        reschedule_message: "再スケジュールメッセージ",
        resend_invite: "招待を再送信",
        reset_password: "パスワードをリセットする",
        restore: "復元する",
        restore_to_defaults: "デフォルトに戻す",
        restore_widget: "ウィジェットを復元",
        resubscribe: "再登録",
        resubscribe_customer: "顧客を再登録する",
        resync: "再同期",
        resync_account: "アカウントの再同期",
        resync_now: "今すぐ再同期",
        retries: "再試行",
        reveal_above_form: "上記のフォームを表示",
        reveal_after_submission: "提出後に公開",
        reveal_below_form: "下のフォームを表示",
        review: "レビュー",
        review_length: "レビューの長さ",
        review_link: "レビューリンク",
        review_missed: "レビュー未達",
        review_not_requested: "レビューは要求されていません",
        review_origin: "このレビューはテンプレートから作成されました",
        review_page: "レビューページ",
        review_pages: "レビューページ",
        review_requested: "レビューをリクエスト",
        review_spotlight: "レビュースポットライト",
        review_suggestion: "レビューの提案",
        review_suggestions: "レビューの提案",
        review_text: "レビューテキスト",
        review_wall: "レビューウォール",
        reviewed: "レビュー済み",
        reviews: "レビュー",
        reviews_ask: "聞く",
        reviews_query_failed: "エラーが発生しました。もう一度お試しください。",
        reviews_query_placeholder: "レビューを検索したり、質問したり…",
        reviews_with_highlights: "ハイライト付きレビュー",
        reviews_with_replies: "返信付きのレビュー",
        reviews_without_replies: "返信のないレビュー",
        revoke: "取り消す",
        revoke_client: "アプリの取り消し",
        roadmap: "ロードマップ",
        role: "役割",
        sans_serif: "サンセリフ",
        save: "保存",
        save_preferences: "設定を保存",
        save_template: "テンプレートを保存",
        save_template_as_new: "新しいテンプレートを保存",
        saved: "保存済み",
        schedule: "スケジュール",
        schedule_review_request: "レビューリクエストのスケジュール",
        scheduled: "予定",
        score: "スコア",
        search: "検索",
        second: "2番",
        secret_key: "秘密鍵",
        sections: "セクション",
        security_code: "セキュリティコード",
        select: "選択",
        select_account: "アカウントを選択",
        select_all: "すべて選択",
        select_an_option: "オプションを選択",
        select_bulk_action: "一括操作を選択",
        select_csv_file: "Csvファイルを選択",
        select_date: "日付を選択",
        select_field: "フィールドを選択",
        select_icon: "アイコンを選択",
        select_location: "場所を選択",
        select_plan: "プランを選択",
        select_review: "レビューを選択",
        select_source: "ソースを選択",
        select_tag: "タグを選択",
        selected: "選択済み",
        send: "送信",
        send_1_reminder: "リマインダーを1件送信",
        send_2_reminders: "2つのリマインダーを送信する",
        send_3_reminders: "3つのリマインダーを送信する",
        send_anytime: "いつでも送信",
        send_between: "送信先",
        send_message: "メッセージを送信",
        send_retries: "{count} 再試行を送信",
        send_retry: "{count} 再試行を送信",
        send_test: "テストを送信",
        send_thanks: "感謝を伝える",
        sender_email_address: "送信者のメールアドレス",
        sender_id: "送信者id",
        sender_name: "送信者名",
        sending_domain: "送信ドメイン",
        sent: "送信済み",
        sent_replies: "送信した返信",
        serif: "セリフ",
        settings: "設定",
        share: "共有",
        share_link: "リンクを共有",
        short: "短い",
        show: "見せる",
        show_1_suggestion: "1件の提案を表示",
        show_100_results: "100件の結果を表示",
        show_2_suggestions: "2つの提案を表示",
        show_25_results: "25件の結果を表示",
        show_3_suggestions: "3つの提案を表示",
        show_4_suggestions: "4つの提案を表示",
        show_5_suggestions: "5つの提案を表示",
        show_50_results: "50件の結果を表示",
        show_all_reviews: "すべてのレビューを表示",
        show_arrows: "矢印を表示",
        show_avatar: "アバターを表示",
        show_cookie_consent_banner: "クッキー同意バナーを表示する",
        show_date: "日付を表示",
        show_dots: "ドットを表示",
        show_drop_shadow: "ドロップシャドウを表示",
        show_field: "次の評価にフィールドを表示",
        show_full: "星をすべて表示する",
        show_photo: "写真のみ表示",
        show_positive_reviews: "肯定的なレビューのみを表示",
        show_to_public: "公開する",
        showcase: "ショーケース",
        showcase_page: "ショーケースページ",
        sign_up: "サインアップ",
        sign_up_for_free: "無料で登録する",
        signature: "署名",
        signatures: "署名",
        signed_up: "サインアップ",
        since: "以来",
        size: "サイズ",
        slug: "Slug",
        small: "小さい",
        sms: "SMS",
        smtp_configuration: "Smtp設定",
        sort: "並べ替え",
        source: "ソース",
        source_code: "ソースコード",
        sources: "出典",
        space: "スペース",
        space_name: "スペース名",
        spaces: "スペース",
        split: "スプリット",
        star_color: "星の色",
        stars: "星",
        start: "始める",
        start_free_trial: "無料トライアルを始める",
        start_getting_more_reviews: "より多くのレビューを獲得し始める",
        status: "状態",
        store_code: "店舗コード",
        strategy: "戦略",
        sub_processors: "サブプロセッサ",
        subject: "主題",
        subscribe: "登録する",
        subscription: "サブスクリプション",
        success_page: "成功ページ",
        suggestion: "提案",
        suggestions: "提案",
        summary: "まとめ",
        suspend: "一時停止",
        suspend_project: "プロジェクトを一時停止",
        suspended: "一時停止中",
        svg: "SVG",
        switch_to_smtp_setup: "Smtp設定に切り替える",
        switch_to_standard_setup: "標準設定に切り替える",
        symbol: "シンボル",
        sync: "同期",
        sync_account: "アカウントを同期",
        sync_now: "今すぐ同期",
        system: "システム",
        system_fonts: "システムフォント",
        tag: "タグ",
        tag_1_customer: "タグ1顧客",
        tag_1_review: "タグ1のレビュー",
        tag_customers: "顧客にタグ付け",
        tag_existing_reviews: "既存のレビューにタグ",
        tag_n_customers: "タグ{count} 顧客",
        tag_n_reviews: "タグ{count}レビュー",
        tag_reviews: "レビューにタグ付け",
        tag_rule: "タグルール",
        tag_with_ai: "Aiタグ",
        tags: "タグ",
        tags_for_customers: "顧客向けタグ",
        tags_for_reviews: "レビューのタグ",
        team: "チーム",
        team_member: "チームメンバー",
        team_members: "チームメンバー",
        template: "テンプレート",
        templates: "テンプレート",
        terms_of_service: "利用規約",
        test_template: "テストテンプレート",
        tests: "テスト",
        text: "文章",
        text_alignment: "テキストの配置",
        text_color: "テキストの色",
        thank_you_messages: "感謝メッセージ",
        thanks: "ありがとう",
        theme: "テーマ",
        third: "三番目",
        time_zone: "タイムゾーン",
        timeframe: "時間枠",
        title: "タイトル",
        tone: "トーン",
        top: "トップ",
        top_left: "左上",
        top_right: "右上",
        total_charges: "合計料金",
        total_reviews: "総レビュー",
        trigger: "トリガー",
        trigger_charged: "請求後にリクエストを送信する",
        trigger_created: "指定日後にリクエストを送信",
        try_free: "無料お試し",
        try_it_free: "無料でお試しください",
        type: "タイプ",
        types: "種類",
        unarchive: "アーカイブ解除",
        unarchive_customer: "顧客のアーカイブを解除",
        underline: "下線",
        unflag_as_duplicate: "重複フラグを解除",
        unknown: "未知",
        unnamed: "名前不明",
        unpublish: "非公開",
        unpublished: "未発表",
        unreplied: "返信なし",
        unsent_messages: "未送信メッセージ",
        unsubscribe: "配信停止",
        unsubscribe_customer: "顧客の配信停止",
        unsubscribe_customers: "顧客の配信停止",
        unsubscribe_text: "配信停止テキスト",
        unsubscribed: "配信停止済み",
        unsuspend: "停止解除",
        unsuspend_project: "プロジェクトの一時停止を解除",
        unverified: "未確認",
        update: "アップデート",
        update_password: "パスワードを更新",
        update_plan: "更新計画",
        update_share_template: "更新テンプレート",
        updated: "更新",
        updates: "アップデート",
        upgrade: "アップグレード",
        upgrade_for_more: "アップグレードしてさらに",
        upgrade_to_use: "この機能を使用するにはアップグレードしてください",
        upload: "アップロード",
        upload_csv: "Csvをアップロード",
        upload_icon: "アイコンをアップロードする",
        url: "URL",
        use: "使用",
        use_filters_for_aggregate: "集計にフィルターを使用する",
        user: "ユーザー",
        user_id: "ユーザーid",
        user_info: "ユーザー情報",
        username: "ユーザー名",
        utc: "UTC",
        validate: "検証",
        validate_customer_email: "顧客のメールを検証する",
        validation: "検証",
        validations: "検証",
        value: "価値",
        verify: "確認する",
        verify_email_address: "メールアドレスを確認する",
        view: "表示",
        view_all: "すべて表示",
        view_all_features: "すべての機能を見る",
        view_available_fields: "利用可能なフィールドを表示",
        view_documentation: "ドキュメントを見る",
        view_email_templates: "メールテンプレートを表示",
        view_review_pages: "レビューページを表示",
        view_reviews: "レビューを見る",
        view_settings: "表示設定",
        view_setup_guide: "セットアップガイドを見る",
        view_showcase: "ショーケースを見る",
        view_strategy: "戦略を見る",
        visibility: "可視性",
        visible: "見える",
        visible_reviews: "表示可能なレビュー",
        visible_to_search_engines: "検索エンジンに表示される",
        wait_between_reminders: "リマインダー間の待ち時間",
        wait_period: "待機期間",
        webhook: "ウェブフック",
        webhooks: "ウェブフック",
        website: "Webサイト",
        weekly: "週刊",
        weeks: "数週間",
        widget: "ウィジェット",
        widgets: "ウィジェット",
        with_ai: "Ai搭載",
        worst_to_best: "最悪から最高へ",
        write: "書く",
        written_reviews: "書面によるレビュー",
        year: "年",
        yearly: "年間",
        yes: "はい",
        your_referral_link: "あなたの紹介リンク"
    },
    landing: {
        announcement: "Aiエージェントと新しいmcpサーバーでレビューワークフローを飛躍的に向上させましょう。",
        callout_1_title: "無料トライアル",
        callout_2_title: "クイックセットアップ",
        callout_3_title: "自動",
        callout_4_title: "フィードバックルーティング",
        counter: "5,000社以上の企業にご参加ください",
        feature_1_subtitle: "顧客にレビューを自動的に依頼します。追加の作業は必要ありません。",
        feature_1_title: "評判を向上させる",
        feature_2_subtitle: "既存のサードパーティのレビューを簡単に追加できます。",
        feature_2_title: "レビューをインポートする",
        feature_3_subtitle: "完全にカスタマイズ可能なウィジェットを使用して、Web サイトにレビューを簡単に表示できます。",
        feature_3_title: "どこでもレビューを展示",
        feature_4_subtitle: "電子メールやsms のリクエストとリマインダーをブランドに合わせてカスタマイズします。",
        feature_4_title: "カスタマイズ可能なテンプレート",
        feature_5_subtitle: "一度設定すれば、レビューのリクエストやリマインダーが送信されたときに当社に処理を任せることができます。",
        feature_5_title: "スマートリクエストスケジューリング",
        feature_6_subtitle: "サードパーティのレビューを収集したり、プライベートフィードバックを集めたり、すべて独自のカスタム ページで行います。",
        feature_6_title: "パーソナライズされたレビューページ",
        feature_7_subtitle: "Ai を活用したレビュー提案により、顧客がより良いレビューを残しやすくなります。",
        feature_7_title: "Aiレビュー提案",
        feature_8_subtitle: "1 つのリンクまたは qr コードから顧客をすべてのレビュー サイトにリダイレクトします。",
        feature_8_title: "あらゆる場所でレビューを集める",
        subtitle: "自動でレビューをリクエスト。5つ星評価を増やし、競合他社よりも上位にランクインしましょう。",
        title: "あなたのaiレピュテーションマネージャー",
        title_contact: "どのようにお手伝いできますか?",
        title_faq: "よくある質問",
        title_features: "レビューをリクエストして紹介するためのオールインワンツールキット",
        title_footer: "もっと良いレビューを獲得する準備はできていますか?",
        title_integrations: "統合",
        title_ltd: "一度支払えば、期間限定の永久割引で永久にご利用いただけます",
        title_reviews: "企業は確かな成果を実感しています。彼らの声をご紹介します。",
        title_tools: "すでに使用しているサービスと統合"
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "顧客を追加してレビューを依頼する",
            customers_to_ask: "レビューを依頼する顧客を探す",
            location_leaderboard: "位置情報のパフォーマンスを比較する",
            outreach_health: "アウトリーチ配信状況の監査",
            review_digest: "週間レビューダイジェスト",
            send_review_requests: "レビュー依頼を一括送信する"
        },
        texts: {
            add_customer_and_ask: "私が提供する連絡先情報を使用して新規顧客を追加し、その後、2回のリマインダー付きでメールでレビュー依頼をスケジュールしてください。",
            customers_to_ask: "レビュー依頼を受けたことのない顧客を最大50人までリストアップしてください。登録日が新しい順に並べてください。配信停止した顧客は除外してください。名前、メールアドレス、登録日を含めてください。",
            location_leaderboard: "地域ごとに、レビュー数、平均評価、5つ星評価の割合、過去90日間との比較トレンドを含む90日間のランキングを作成します。評価順に並べ替え、0.2つ星以上の低下があった場合はフラグを立てます。",
            outreach_health: "過去14日間に送信されたメールメッセージについて、送信総数、配信率、開封率、クリック率、および配信失敗率を報告してください。異常値があれば報告してください。",
            review_digest: "過去7日間のすべてのレビューを要約してください。件数、平均評価、情報源と地域別の内訳、上位3つのテーマ、上位3つの懸念事項を含めてください。",
            send_review_requests: "過去30日以内に登録されたお客様で、まだレビュー依頼を受けていないお客様には、メールでレビュー依頼を送信し、2回のリマインダーをお送りします。まずはリストを表示し、私の確認をお待ちください。"
        }
    },
    messages: {
        activated: "正常に有効化されました。",
        archived: "正常にアーカイブされました。",
        canceled: "キャンセルに成功しました。",
        cannot_copy: "クリップボードにコピーできません",
        cname_active: "Cnameの状態はアクティブです。",
        cname_not_active: "Cnameステータスはまだアクティブではありません。",
        connected: "接続に成功しました。",
        cookie_banner_text: "当サイトでは、お客様の利便性向上のためクッキーを使用しています。設定をカスタマイズするか、すべてのクッキーを受け入れることができます。",
        cookie_category_analytics_desc: "ウェブサイトのトラフィックと製品の使用状況を測定するために使用されます。これらのクッキーは、訪問者が当サイトをどのように利用しているかを理解するのに役立ちます。",
        cookie_category_essential_desc: "常に有効です。これらのクッキーはサイトの機能に不可欠であり、無効にすることはできません。",
        cookie_category_functional_desc: "ライブチャットなどの拡張機能を有効にします。これらのクッキーは広告目的でユーザーを追跡することはありません。",
        cookie_category_marketing_desc: "広告およびキャンペーン測定に使用されます。これには、広告ピクセルやアトリビューションツールなどが含まれます。",
        copied: "コピーに成功しました。",
        created: "正常に作成されました。",
        deactivated: "無効化に成功しました。",
        deleted: "正常に削除されました。",
        disconnected: "切断に成功しました。",
        duplicated: "複製に成功しました。",
        oauth_consent_intro: "{client} があなたのアカウントへのアクセス許可を要求しています。",
        oauth_request_missing: "OAuth認証リクエストが存在しないか、期限切れです。",
        processed: "正常に処理されました。",
        published: "正常に公開されました。",
        purchased: "購入に成功しました。",
        queued: "正常にスケジュールされました。",
        refreshed: "正常に更新されました。",
        removed: "正常に削除されました。",
        resubscribed: "再登録に成功しました。",
        revoked: "取り消しに成功しました。",
        saved: "正常に保存済み。",
        scheduled: "正常にスケジュールされました。",
        sent: "送信に成功しました。",
        started: "正常に開始されました。",
        stopped: "正常に停止しました。",
        subscribed: "購読が完了しました。",
        suspended: "停止に成功しました。",
        synced: "同期に成功しました。",
        unarchived: "正常にアーカイブ解除されました。",
        unpublished: "非公開に成功しました。",
        unscheduled: "スケジュール解除に成功しました。",
        unsubscribed: "登録解除に成功しました。",
        unsuspended: "停止解除に成功しました。",
        updated: "正常に更新されました。",
        upgraded: "アップグレードに成功しました。",
        validated: "検証に成功しました。",
        verified: "検証に成功しました。"
    },
    notices: {
        agency: "代理店を経営されていますか? 当社の製品をホワイトラベル化することで、サービス使用時に顧客に自社のブランドのみが表示されるようになります。",
        connected_apps: "Mcp経由で接続したアプリはここに表示されます。",
        connector: "{brand} を使用して、何千ものアプリケーションから顧客をインポートします。",
        customer_messages: "メッセージをスケジュールするにはレビューをリクエストしてください。",
        customer_reviews: "この顧客にレビューをリクエストします。",
        customers: "レビューを開始するには、顧客をインポートします。",
        external_links: "顧客ポータルに外部リンクを追加して、サービスの販売を促進しましょう。これらのリンクは、サイドバーで顧客に表示されます。",
        links: "サードパーティの Web サイトにレビューを残すためのボタンをページに追加します。",
        locations: "場所を作成すると、レビューを複数の場所に関連付けることができます。",
        ltd: "アクセスコードを入力すると、永久アクセスが解除されます。各コードには、月間リクエスト数とすべての機能が含まれています。コードは重複して使用できます。3つのコードを入力すると、すべてのブランド表示が解除され、エージェンシー向け機能が解除されます。下記にアクセスコードを入力してください。",
        mcp_example_prompts: "Mcpサーバーに接続したら、まずこれらの内容をアシスタントに貼り付けてください。",
        messages: "顧客からレビューを依頼されると、すべてのリクエストとリマインダーがここに表示されます。",
        no_commissions: "あなたはまだ報酬を獲得していません。",
        no_payouts: "承認された残高が50ドル以上になり、銀行口座が連携されると、支払いは手動で行われます。",
        no_referrals: "まだ誰も紹介していません。紹介リンクを共有して始めましょう。",
        projects: "まだプロジェクトはありません。",
        qr_codes: "色、位置、タグをカスタマイズしたqrコードを作成できます。SVGまたはPNGでダウンロード可能です。",
        referrals_share_subject: "私のaiレピュテーションマネージャー",
        referrals_share_text: "ビジネスレビューを獲得するための私の秘密兵器： さらに良いレビュー。実際に効果のあるaiレピュテーションマネジメント。私のリンクから登録してください。",
        review_pages: "プロジェクトには、顧客がレビューを投稿できる複数のレビューページを作成できます。これは、複数の拠点を持つビジネスに便利です。",
        reviews: "お客様からのレビューをお待ちしております。",
        showcase: "まだ始まったばかりです。",
        signatures: "メール署名を作成し、それをコピーしてメールアプリケーションに貼り付けてください。",
        sources: "レビューを分類できるようにソースを作成します。",
        tag_rules: "Ai を使用してレビューを自動的に分類するルールを作成します。",
        tags: "レビューと顧客を分類するためのタグを作成します。",
        unauthorized: "このページにアクセスする権限がありません。",
        unsubscribed: "レビューリクエストの登録が解除されました。",
        webhooks: "プラットフォーム イベントに関する通知を受け取るには、Webhook を追加します。",
        widgets: "ウィジェットを作成して、ウェブサイトにレビューを埋め込みます。",
        your_referral_link_text: "リンクを共有して、紹介した顧客からの支払いごとに{rate}%の継続コミッションを獲得しましょう。承認された残高が50.00ドル以上になると、支払いは手動で行われます。"
    },
    notification_types: {
        descriptions: {
            imports: "インポートが完了したら送信されます",
            new_reviews: "レビューを受け取ったら送信されます",
            sent_replies: "レビューに自動返信すると送信されます",
            weekly_reports: "毎週送信されるアクティビティの要約"
        },
        names: {
            imports: "インポート",
            new_reviews: "新しいレビュー",
            sent_replies: "送信した返信",
            weekly_reports: "週次レポート"
        }
    },
    roles: {
        manager: "マネージャー",
        operator: "オペレーター",
        owner: "所有者",
        super_admin: "管理者",
        viewer: "閲覧者"
    },
    tasks: {
        automate: "お客様に継続的にレビューを依頼しましょう。自動レビュー収集を有効にすると、お客様にレビュー依頼を継続的に送信します。リマインダーを送信することも可能です。自動レビュー収集はお客様ごとに1回のみ実行され、お客様はいつでも登録を解除できます。",
        customers: "レビューを依頼するには、お客様の氏名、メールアドレス、電話番号など、お客様の基本情報をご提供いただく必要があります。お客様の情報は手動でインポートすることも、 Stripe、 HubSpot、アプリコネクタ、またはAPIを使用して自動でインポートすることもできます。また、請求書をお客様に送信する際に、プロジェクトのメールアドレスをBCCで送信することも可能です。",
        project: "プロジェクトの設定おめでとうございます！各プロジェクトは、あなたのビジネスに代わってレビューリクエストを送信できます。",
        review_page: "レビューページは、レビューやフィードバックを収集し、サードパーティのウェブサイトにレビューを投稿するか、サードパーティのウェブサイトにリダイレクトするかを選択できる場所です。テキスト、レイアウト、フォームフィールド、サードパーティへのリンクやリダイレクトなど、すべてをカスタマイズできます。",
        strategy: "顧客にレビューを依頼するタイミングは、あなたの戦略によって決まります。基本的な戦略からスタートしましたが、カスタマイズすることも可能です。",
        templates: "リクエストとリマインダーのテンプレートは、顧客にレビューを依頼するために送信されます。どちらのテンプレートにも、ワンクリックで評価を送信できるオプションとカスタマイズ可能なテキストが含まれています。独自のロゴやブランドを追加することもできます。"
    },
    titles: {
        accept_invite: "招待を承諾",
        accepting_invite: "招待を承諾",
        access_denied: "アクセスが拒否されました",
        account: "アカウント",
        actions: "アクション",
        add_custom_field: "カスタムフィールドを追加",
        add_ons: "アドオン",
        address: "住所",
        agency: "代理店",
        ai_assistant: "Aiアシスタント",
        ai_highlights: "Aiのハイライト",
        ai_replies: "Aiの返信",
        ai_review_suggestions: "Aiレビュー提案",
        analytics: "分析",
        api: "API",
        api_key: "Apiキー",
        appearance: "外観",
        application_connectors: "アプリケーションコネクタ",
        attributes: "属性",
        authorize: "承認する",
        auto_tagging: "自動タグ付け",
        automatic_review_collection: "自動レビュー収集",
        billing: "請求",
        branding: "ブランディング",
        change_password: "パスワードを変更する",
        clients: "クライアント",
        cname: "CNAME",
        conditions: "条件",
        connected_apps: "接続されたアプリ",
        contact_us: "お問い合わせ",
        cookie_policy: "クッキーポリシー",
        cookie_preferences: "クッキーの設定",
        copy: "コピー",
        create_your_account: "アカウントを作成",
        crms: "CRMs",
        css: "CSS",
        custom_field: "カスタムフィールド",
        custom_fields: "カスタムフィールド",
        custom_icons: "カスタムアイコン",
        customer: "お客様",
        customer_facing_pages: "顧客向けページ",
        customers: "顧客",
        dashboard: "ダッシュボード",
        details: "詳細",
        dmarc: "DMARC",
        domain: "ドメイン",
        dpa: "データ処理契約",
        dsar: "データ主体アクセス要求",
        email_address: "電子メールアドレス",
        email_messages: "電子メールメッセージ",
        email_settings: "メール設定",
        email_usage: "メールの使用",
        emails: "メール",
        embed_code: "埋め込みコード",
        examples: "例",
        export: "エクスポート",
        external_link: "外部リンク",
        external_link_num: "外部リンク#{num}",
        external_links: "外部リンク",
        field: "フィールド",
        fields: "フィールド",
        filters: "フィルター",
        form_fields: "フォームフィールド",
        got_access_code: "アクセスコードをお持ちですか?",
        how_it_works: "仕組み",
        incentive: "インセンティブ",
        instructions: "説明書",
        integration: "統合",
        integrations: "統合",
        javascript: "JavaScript",
        latest_reviews: "最新のレビュー",
        lifetime_deal: "生涯契約",
        limits: "制限",
        link: "リンク",
        links: "リンク",
        location: "位置",
        location_picker: "場所ピッカー",
        locations: "場所",
        log_in: "ログイン",
        log_out: "ログアウト",
        make_default: "デフォルトにする",
        manage_limits: "制限を管理する",
        manage_overrides: "オーバーライドの管理",
        manage_review: "レビューの管理",
        mcp_example_prompts: "プロンプト例",
        mcp_server: "Mcpサーバー",
        message: "メッセージ",
        messages: "メッセージ",
        meta: "メタ",
        no_clients: "クライアントなし",
        no_commissions: "手数料なし",
        no_connected_apps: "接続されたアプリはありません",
        no_custom_fields: "カスタムフィールドなし",
        no_customers: "顧客なし",
        no_links: "リンクなし",
        no_locations: "場所なし",
        no_members: "メンバーなし",
        no_messages: "メッセージなし",
        no_payouts: "支払いなし",
        no_projects: "プロジェクトなし",
        no_qr_codes: "Qrコードなし",
        no_referrals: "紹介制度なし",
        no_review_pages: "レビューページなし",
        no_reviews: "レビューなし",
        no_tags: "タグなし",
        no_team_members: "チームメンバーなし",
        no_template: "テンプレートなし",
        no_widgets: "ウィジェットなし",
        notifications: "通知",
        options: "オプション",
        overview: "概要",
        payment_method: "支払方法",
        photo: "写真",
        plans: "プラン",
        powered_by: "Powered by",
        pricing: "価格",
        privacy_policy: "プライバシーポリシー",
        profile: "プロフィール",
        project: "プロジェクト",
        project_limits: "プロジェクトの制限",
        project_overrides: "プロジェクトのオーバーライド",
        project_setup: "プロジェクトのセットアップ",
        projects: "プロジェクト",
        qr_code: "Qrコード",
        qr_codes: "Qrコード",
        ratings: "評価",
        redeem_access_code: "アクセスコードを利用する",
        redirecting: "リダイレクト",
        redirects: "リダイレクト",
        referrals_commissions: "手数料",
        referrals_payouts: "支払い",
        referral_program: "紹介プログラム規約",
        reminders: "リマインダー",
        reply: "返事",
        request: "リクエスト",
        request_options: "リクエストオプション",
        requests: "リクエスト",
        required: "必須",
        reschedule_message: "再スケジュールメッセージ",
        reset_password: "パスワードをリセットする",
        retries: "再試行",
        review: "レビュー",
        review_link: "レビューリンク",
        review_page: "レビューページ",
        review_pages: "レビューページ",
        review_spotlight: "レビュースポットライト",
        review_suggestions: "レビューの提案",
        review_wall: "レビューウォール",
        reviewer: "レビュアー",
        reviews: "レビュー",
        save_changes: "変更を保存",
        schedule: "スケジュール",
        search_engines: "検索エンジン",
        sections: "セクション",
        select_csv_file: "Csvファイルを選択",
        selecting_project: "プロジェクトの選択",
        sending_domain: "送信ドメイン",
        sending_limits: "送信制限",
        settings: "設定",
        setup: "設定",
        showcase: "ショーケース",
        sign_up: "サインアップ",
        signature: "署名",
        signatures: "署名",
        signing_in: "サインイン",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Smsメッセージ",
        sms_usage: "Smsの使用",
        smtp_configuration: "Smtp設定",
        source: "ソース",
        sources: "出典",
        space: "スペース",
        spaces: "スペース",
        stats: "統計",
        sub_processors: "サブプロセッサ",
        success_page: "成功ページ",
        summary: "まとめ",
        tag: "タグ",
        tag_rule: "タグルール",
        tags: "タグ",
        team_members: "チームメンバー",
        template: "テンプレート",
        templates: "テンプレート",
        terms_of_service: "利用規約",
        two_factor_authentication: "二要素認証",
        unable_to_complete_request: "リクエストを完了できませんでした",
        unique_review_link: "固有のレビューリンク",
        unsent_messages: "未送信メッセージ",
        unsubscribe: "配信停止",
        update_plan: "更新計画",
        usage: "使用法",
        user: "ユーザー",
        user_info: "ユーザー情報",
        verify_email_address: "メールアドレスを確認する",
        verifying_email: "メールの確認",
        visibility: "可視性",
        webhook: "ウェブフック",
        webhooks: "ウェブフック",
        website: "Webサイト",
        white_label_api: "ホワイトラベルapi",
        white_label_client_portal: "ホワイトラベルクライアントポータル",
        white_label_image_urls: "ホワイトラベル画像url",
        white_label_sending_domain: "ホワイトラベル送信ドメイン",
        white_label_widget_tag: "ホワイトラベルウィジェットタグ",
        widget: "ウィジェット",
        widget_num: "ウィジェット #{num}",
        widgets: "ウィジェット",
        your_plan: "ご利用中のプラン"
    },
    tones: {
        apologetic: "謝罪",
        casual: "カジュアル",
        empathetic: "共感的",
        enthusiastic: "熱狂的",
        formal: "フォーマル",
        friendly: "フレンドリー",
        grateful: "ありがたい",
        humorous: "ユーモラス",
        informative: "有益な"
    },
    widgets: {
        labels: {
            alignment: "アライメント",
            animation: "アニメーション",
            autoplay: "自動再生",
            autoplay_delay: "自動再生遅延",
            avatar: "アバター",
            background_color: "背景色",
            border: "枠線",
            border_color: "境界線の色",
            border_radius: "境界半径",
            border_width: "境界線の幅",
            carousel: "カルーセル",
            colors: "色",
            company: "会社",
            customer: "お客様",
            customer_position: "顧客情報の位置",
            date: "日付",
            delay: "遅れ",
            drop_shadow: "ドロップシャドウ",
            duration: "間隔",
            filters: "フィルター",
            font: "フォント",
            font_emphasis: "フォントの強調",
            font_family: "フォントファミリー",
            font_size: "フォントサイズ",
            include_hidden: "非表示のレビューを含める",
            layout: "レイアウト",
            limit: "ページあたりのレビュー",
            location_ids: "場所",
            marquee: "マーキー",
            max_slides: "マックススライド",
            max_width: "最大幅",
            name_convention: "名前",
            padding: "パディング",
            pagination: "ページネーション",
            quotes: "引用",
            rating: "評価",
            rating_round: "丸め",
            rating_round_hundredth: "小数点以下第2位 (4.94)",
            rating_round_tenth: "小数点以下第1位（4.9）",
            review: "レビュー",
            review_chars: "レビューの長さ",
            review_count: "レビュー数",
            review_id: "レビュー",
            review_ids: "レビュー",
            review_ids_for_faces: "フェイスのレビュー",
            reviews: "レビュー",
            schema: "スキーマ",
            schema_name: "会社名",
            schema_type: "事業形態",
            score: "最低評価",
            show_on_mobile: "モバイルで表示",
            slider: "スライダー",
            source: "ソース",
            source_ids: "出典",
            source_position: "ソース位置",
            speed: "スピード",
            star_color: "星の色",
            star_display: "星の表示",
            star_size: "星の大きさ",
            tag_ids: "タグ",
            take: "レビューの最大数",
            text_color: "テキストの色",
            truncate: "レビューを短縮",
            visible_slides: "表示スライド",
            width: "幅"
        },
        types: {
            badge: "バッジ",
            carousel: "カルーセル",
            carousel_dynamic: "ダイナミックカルーセル",
            corner: "コーナー",
            corner_dynamic: "ダイナミックコーナー",
            faces: "顔",
            headline: "見出し",
            highlights: "ハイライト",
            marquee: "マーキー",
            spotlight: "スポットライト",
            wall: "ウォール"
        }
    }
}